import { Currency } from './types/basket-types';

export function minorUnitToMajor(_currency: Currency, amount: number) {
  return amount / 100;
}

export const toSafeMinorCurrency = (value: string) => Math.round(parseFloat(parseFloat(value).toFixed(2)) * 100);

export function toDisplayCurrency(currency: Currency, amount: number, minimumFractionDigits: number = 2) {
  const value = minorUnitToMajor(currency, amount);
  return value.toLocaleString(undefined, {
    style: 'currency',
    currency: currency.code,
    minimumFractionDigits: minimumFractionDigits,
    currencyDisplay: 'narrowSymbol'
  });
}

export function displayCurrencySymbol(currency: Currency) {
  return toDisplayCurrency(currency, 0, 0).replace(/[\d.,]/g, '');
}
